import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import numeral from 'numeral'
import {
  Div, P, Input, Button as KSButton, Loading, DynamicButtonLink,
} from 'konsys-ui'
import {
  Button, Select, Modal, Descriptions, Input as AntInput, Upload, Spin, message, Badge, Icon, Row, Col, Checkbox, Radio, AutoComplete,
} from 'antd'
import { Query, Mutation } from 'react-apollo'
import { useQuery } from '@apollo/react-hooks'
import { TIRE_SERIAL_NUMBER_LIST, INVENTORIES, TIRE_SERIAL_NUMBER_INFO } from '../../../constants/graph/query'
import { GET_MECHANICS, GET_SKILL_LIST } from '../../../constants/graphql/query'
import {
  CREATE_REPAIR_SERVICE, UPDATE_REPAIR_SERVICE, ASSIGN_MECHANIC, START_SERVICE, CLOSE_SERVICE, CANCEL_SERVICE, START_SERVICE_TIRE, CLOSE_SERVICE_TIRE,
} from '../../../constants/graphql/mutation'
import {
  DropdownSelector,
} from '../../../components/repair-job-components'
import { servicesStatus, status } from '../constants'
import { badgeColorSelector, servicesTextSelector } from '../list'
import { checkInt, checkFloat } from '../../../utils/util-services'
import PERMISSION from '../../../constants/permissions'
import { getAccessToken, getURL } from '../../../utils/local-data-service'
import { STATUS, STATUSTEXTSELECTOR, LOSTREASON } from '../../tire-inventory-page/constants'
import { UploadWithModal } from '../../../components/common'

export const STATUSRETURN = [
  { value: 'OLDSTOCK', text: 'สต๊อกเก่า' },
  { value: 'WAITFORSALE', text: 'รอจำหน่าย' },
  { value: 'SOLD', text: 'ขายแล้ว' },
  { value: 'LOST', text: 'นำออก' },
]

export default ({
  services, jobId, refetch, setCloseJobModal, jobStatus, info,
}) => {
  const [createModal, setCreateModal] = useState(false)
  const [newService, setNewService] = useState({})
  const [searchMechanic, setSearchMechanic] = useState()
  const {
    loading: skillLoading, data: skillData, error: skilError, refetch: skillRefetch,
  } = useQuery(GET_SKILL_LIST)
  useEffect(() => {
    setNewService({
      isRepairTruck: false,
      isRepairTrailer: false,
    })
  }, [createModal])
  return (
    <Div padding='40px 0' display='flex' flexDirection='column' width='100%'>
      {
        services.map(v => <ServiceInfo jobStatus={jobStatus} setCloseJobModal={setCloseJobModal} key={v.id} service={v} refetch={refetch} info={info} />)
      }
      <Button icon="plus" type="primary" block size='large' onClick={() => setCreateModal(true)} disabled={!_.includes([status.WAITING, status.INPROGRESS, status.NOTIFY], jobStatus)}>เพิ่มงานซ่อม</Button>
      <Create
        refetch={refetch}
        jobId={jobId}
        createModal={createModal}
        setCreateModal={setCreateModal}
        newService={newService}
        setNewService={setNewService}
        searchMechanic={searchMechanic}
        setSearchMechanic={setSearchMechanic}
        info={info}
        skillLoading={skillLoading}
        skillData={skillData}
      />
    </Div>
  )
}

/* TODO
 cancel

*/

const ServiceInfo = ({
  service, refetch, setCloseJobModal, jobStatus, info,
}) => {
  const [editModal, setEditModal] = useState(false)
  const [assignMechanicModal, setAssignMechanicModal] = useState(false)
  const [startServiceModal, setStartServiceModal] = useState(false)
  const [startServiceTireModal, setStartServiceTireModal] = useState(false)
  const [closeServiceModal, setCloseServiceModal] = useState(false)
  const [closeServiceTireModal, setCloseServiceTireModal] = useState(false)
  const [cancelServiceModal, setCancelServiceModal] = useState(false)
  const {
    loading: skillLoading, data: skillData, error: skilError, refetch: skillRefetch,
  } = useQuery(GET_SKILL_LIST)
  const {
    loading: inventoryLoading, data: inventoryData, error: inventoryError, refetch: inventoryRefetch,
  } = useQuery(INVENTORIES)
  const {
    loading: tireSerialNumberLoading, data: tireSerialNumberData, error: tireSerialNumberError, refetch: tireSerialNumberRefetch,
  } = useQuery(TIRE_SERIAL_NUMBER_LIST, {
    variables: {
      warehouseId: info.Warehouse.id,
    },
  })

  return (
    <Div display='flex' flexDirection='column' alignItems='flex-end' width='100%'>
      <Div display='flex' justifyContent='space-between' alignItems='center' width='100%'>
        <Badge status={badgeColorSelector(service.status)} text={servicesTextSelector(service.status)} />
        <span>
          {service.status === servicesStatus.STARTED && <Button icon="check-circle" style={{ borderRadius: '4px 4px 0px 0px', margin: '0 4px' }} type='primary' onClick={() => {
            if (service.serviceType === 'NORMAL') setCloseServiceModal(true)
            else setCloseServiceTireModal(true)
          }}>ปิดงาน</Button>}
          {service.status === servicesStatus.ASSIGNED && <Button icon="caret-right" style={{ borderRadius: '4px 4px 0px 0px', margin: '0 4px' }} type='primary' onClick={() => {
            if (service.serviceType === 'NORMAL') setStartServiceModal(true)
            else setStartServiceTireModal(true)
          }}>เริ่มงาน</Button>}
          {service.status === servicesStatus.WAITING && <Button icon="user-add" style={{ borderRadius: '4px 4px 0px 0px', margin: '0 4px' }} type='primary' onClick={() => setAssignMechanicModal(true)}>จ่ายงาน</Button>}
          {!_.includes([servicesStatus.DONE, servicesStatus.CANCEL], service.status) && <Button icon="edit" style={{ borderRadius: '4px 4px 0px 0px', margin: '0 4px' }} type='primary' onClick={() => setEditModal(true)}>อัพเดท</Button>}
          {/* {_.includes([servicesStatus.DONE], service.status) && !_.includes([status.CANCEL, status.COMPLETED], jobStatus) && <Button icon="edit" style={{ borderRadius: '4px 4px 0px 0px', margin: '0 4px' }} type='primary' onClick={() => setCloseServiceModal(true)}>แก้ไขการซ่อม</Button>} */}
          {!_.includes([servicesStatus.DONE, servicesStatus.CANCEL], service.status) && service.serviceType === 'NORMAL' && <Button icon="close-circle" style={{ borderRadius: '4px 4px 0px 0px', margin: '0 4px' }} onClick={() => setCancelServiceModal(true)}>ยกเลิก</Button>}
        </span>
      </Div>
      <Descriptions column={{ xs: 1, sm: 1, md: 1 }} bordered border style={{ marginBottom: 24, width: '100%', background: '#fff' }} size='small'>
        <Descriptions.Item label="ช่าง">{service.status !== servicesStatus.WAITING ? service.Mechanic.fullname : 'รอการจ่ายงาน'}</Descriptions.Item>
        <Descriptions.Item label="รถที่ซ่อม">{<P display='block'>{service.isRepairTrailer === false ? 'งานซ่อมรถบรรทุก' : 'งานซ่อมหางพ่วง'}</P>}</Descriptions.Item>
        {!_.isEmpty(service.RepairSkill)
          && <Descriptions.Item label="ประเภทของงาน">{service.RepairSkill.map(v => <P key={v.id} display='block'>{v.name}</P>)}</Descriptions.Item>
        }
        {service.serviceType === 'NORMAL'
          && <Descriptions.Item label="อะไหล่">{service.ItemBorrows.map(v => <P key={v.id} display='block'>{v.name} ราคา {numeral(v.pricePerItem).format('0,0.00')} บาท จำนวน: {v.amount}</P>)}</Descriptions.Item>
        }
        {service.serviceType === 'TIRE'
          && <Descriptions.Item label="ยาง">{service.ItemBorrows.map(v => <P key={v.id} display='block'>{v.serialNo} ราคา {numeral(v.pricePerItem).format('0,0.00')} บาท</P>)}</Descriptions.Item>
        }
        {/* <Descriptions.Item label="อะไหล่">{service.ItemBorrows.map(v => <P key={v.id} display='block'>{v.name} จำนวน: {v.amount} Serial No. {v.serialNo}</P>)}</Descriptions.Item> */}
        {
          service.status === servicesStatus.DONE && service.serviceType === 'NORMAL' && <Descriptions.Item label="คืนอะไหล่">{service.ItemReturns.map(v => <P key={v.id} display='block'>{v.name} จำนวน: {v.amount}</P>)}</Descriptions.Item>
        }
        {
          service.status === servicesStatus.DONE && service.serviceType === 'TIRE' && <Descriptions.Item label="คืนยาง">{service.ItemReturns.map(v => <P key={v.id} display='block'>{v.name} </P>)}</Descriptions.Item>
        }
        {service.serviceType === 'NORMAL'
          && <Descriptions.Item label="ราคาอะไหล่รวม"><P>{numeral(_.reduce(service.ItemBorrows, (sum, v) => {
            const amount = service.ItemReturns && _.find(service.ItemReturns, o => o.sku === v.sku)
              ? v.amount - _.find(service.ItemReturns, o => o.sku === v.sku).amount > 0
                ? v.amount - _.find(service.ItemReturns, o => o.sku === v.sku).amount
                : 0
              : v.amount
            return amount * v.pricePerItem + sum
          }, 0)).format('0,0.00')} บาท</P></Descriptions.Item>
        }
        {service.serviceType === 'TIRE'
          && <Descriptions.Item label="ราคายางรวม"><P>{numeral(_.reduce(service.ItemBorrows, (sum, v) => v.pricePerItem + sum, 0)).format('0,0.00')} บาท</P></Descriptions.Item>
        }
        {
          service.status === servicesStatus.CANCEL && <Descriptions.Item label="เหตุผลที่ยกเลิกงาน">{service.cancelReason}</Descriptions.Item>
        }
        <Descriptions.Item label="หมายเหตุ">
          {service.remark}
        </Descriptions.Item>
        <Descriptions.Item label="รูปก่อนซ่อม">{service.BeforeRepairFiles.map(v => <div key={v.id}><a href={v.url}>{v.filename}</a></div>)}</Descriptions.Item>
        {
          service.status === servicesStatus.DONE && <Descriptions.Item label="รูปหลังซ่อม">{service.AfterRepairFiles.map(v => <div key={v.id}><a href={v.url}>{v.filename}</a></div>)}</Descriptions.Item>
        }
      </Descriptions>
      <Edit
        refetch={refetch}
        editModal={editModal}
        setEditModal={setEditModal}
        service={service}
        skillLoading={skillLoading}
        skillData={skillData}
      />
      <AssignMechanic
        refetch={refetch}
        assignMechanicModal={assignMechanicModal}
        setAssignMechanicModal={setAssignMechanicModal}
        service={service}
      />
      <StartServiceTire
        refetch={refetch}
        startServiceTireModal={startServiceTireModal}
        setStartServiceTireModal={setStartServiceTireModal}
        service={service}
        info={info}
        tireSerialNumberLoading={tireSerialNumberLoading}
        tireSerialNumberData={tireSerialNumberData}
        tireSerialNumberRefetch={tireSerialNumberRefetch}
      />
      <StartService
        refetch={refetch}
        startServiceModal={startServiceModal}
        setStartServiceModal={setStartServiceModal}
        service={service}
        info={info}
        inventoryLoading={inventoryLoading}
        inventoryData={inventoryData}
        inventoryRefetch={inventoryRefetch}
      />
      <CloseServiceTire
        refetch={refetch}
        closeServiceTireModal={closeServiceTireModal}
        setCloseServiceTireModal={setCloseServiceTireModal}
        service={service}
        setCloseJobModal={setCloseJobModal}
        info={info}
        tireSerialNumberLoading={tireSerialNumberLoading}
        tireSerialNumberData={tireSerialNumberData}
        tireSerialNumberRefetch={tireSerialNumberRefetch}
      />
      <CloseService
        refetch={refetch}
        closeServiceModal={closeServiceModal}
        setCloseServiceModal={setCloseServiceModal}
        service={service}
        setCloseJobModal={setCloseJobModal}
        info={info}
        inventoryLoading={inventoryLoading}
        inventoryData={inventoryData}
        inventoryRefetch={inventoryRefetch}
      />
      <CancelService
        refetch={refetch}
        cancelServiceModal={cancelServiceModal}
        setCancelServiceModal={setCancelServiceModal}
        service={service}
        setCloseJobModal={setCloseJobModal}
      />
    </Div>
  )
}

const Create = ({
  createModal, setCreateModal, newService, setNewService, searchMechanic, setSearchMechanic, jobId, refetch, info, skillData, skillLoading,
}) => (
    <Mutation
      mutation={CREATE_REPAIR_SERVICE}
    >{(doCreate, { loading: doLoading }) => (
      <Modal
        title="เพิ่มงานซ่อม"
        visible={createModal}
        okButtonProps={{
          loading: doLoading,
          disabled: _.isUndefined(newService.isRepairTruck)
          || _.isUndefined(newService.isRepairTrailer)
          || _.isUndefined(newService.serviceType)
          || _.isEmpty(newService.skillId)
          || (newService.isRepairTruck === newService.isRepairTrailer)
          || _.isUndefined(newService.serviceType)
          || doLoading,
        }}
        cancelButtonProps={{ disabled: doLoading }}
        okText='เพิ่มงานซ่อม'
        destroyOnClose={true}
        onCancel={() => setCreateModal(false)}
        onOk={() => {
          setNewService({})
          doCreate({
            variables: { ...newService, repairId: _.toSafeInteger(jobId) },
          }).then((resp) => {
            const response = resp.data.CreateRepairService
            if (response.success) {
              message.success(response.message)
              refetch()
            } else message.error(response.message)
            setCreateModal(false)
          })
        }}
      >
        <Div display='flex' flexDirection='column'>
          <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center' margin='0 0 8px 0'>
            <P bold>ช่าง</P>
            <Query
              query={GET_MECHANICS}
              variables={{ fullname: searchMechanic, limit: 10 }}
            >{({ data, loading, error }) => {
              if (loading && _.isUndefined(data.MechanicList)) return <Loading size='small' />
              if (error) return <P>Error</P>
              return (
                <Select
                  showSearch
                  style={{ width: '40%' }}
                  loading={loading}
                  onSelect={e => setNewService({ ...newService, mechanicId: e })}
                  onSearch={e => setSearchMechanic(e)}
                  placeholder='พิมพ์เพื่อค้นหา'
                  notFoundContent={loading ? <Spin size="small" /> : null}
                  optionFilterProp="children"
                >
                  {
                    data.MechanicList.lists.map(v => <Select.Option key={v.id} value={v.id}>{v.fullname}</Select.Option>)
                  }
                </Select>
              )
            }}
            </Query>
          </Div>
          <Div display='inline-block' flexDirection='row' margin='0 0 8px 0'>
            <Div display='block'>
              <P bold margin='0 0 8px 0'>รถที่ซ่อม</P>
            </Div>
            <Div display='inline-block' flexDirection='column'>
              <Radio.Group
                onChange={(e) => {
                  if (e.target.value) setNewService({ ...newService, isRepairTruck: e.target.value, isRepairTrailer: !e.target.value })
                  else setNewService({ ...newService, isRepairTruck: e.target.value, isRepairTrailer: !e.target.value })
                }}
              >
                <Radio value={true} disabled={(!info.isRepairTruck && info.isRepairTrailer)}>งานซ่อมรถบรรทุก</Radio>
                <Radio value={false} disabled={(info.isRepairTruck && !info.isRepairTrailer)}>งานซ่อมหางพ่วง</Radio>
              </Radio.Group>
            </Div>
            <Div display='block'>
              <P bold margin='8px 0'>รูปแบบงานซ่อม</P>
            </Div>
            <Div display='inline-block' flexDirection='column'>
              <Radio.Group
                onChange={(e) => {
                  if (e.target.value) setNewService({ ...newService, serviceType: 'NORMAL', skillId: undefined })
                  else setNewService({ ...newService, serviceType: 'TIRE', skillId: [10] })
                }}
              >
                <Radio value={true}>งานซ่อมทั่วไป</Radio>
                <Radio value={false}>งานซ่อมยาง</Radio>
              </Radio.Group>
            </Div>
          </Div>
          { (!skillLoading || !_.isEmpty(skillData)) && newService.serviceType === 'NORMAL'
            && <Div display='flex' flexDirection='column' margin='0'>
            <P margin='8px 0 16px'>ประเภทของงาน *</P>
            <Checkbox.Group
              style={{ width: '100%' }}
              onChange={e => setNewService({ ...newService, skillId: e })}
            >
            <Row>
            {_.map(skillData.RepairSkillList.lists, (v) => {
              if (v.name === 'ยาง') return ''
              return (
                <Col span={12} style={{ margin: '8px 0' }}>
                  <Checkbox value={v.id}>
                    <P>{v.name}</P>
                  </Checkbox>
                </Col>
              )
            })}
            </Row>
            </Checkbox.Group>
          </Div>
          }
          <P bold margin='0 0 8px 0'>รายละเอียด</P>
          <AntInput.TextArea onChange={e => setNewService({ ...newService, remark: e.target.value })} />
          <P bold margin='16px 0'>รูปก่อนซ่อม</P>
          <UploadWithModal
            onChange={e => setNewService({ ...newService, beforeRepairImages: e.fileList.map(v => v.originFileObj) })}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            listType='picture'
          />
        </Div>
      </Modal>
    )}
    </Mutation>
)

const Edit = ({
  editModal, setEditModal, refetch, service, skillData, skillLoading,
}) => {
  const [updatedService, setUpdatedService] = useState()
  const [searchMechanic, setSearchMechanic] = useState()
  const [partList, setPartList] = useState(service.ItemBorrows)
  const [skillId, setSkillId] = useState(_.map(service.RepairSkill, v => v.id))

  return (
    <Mutation
      mutation={UPDATE_REPAIR_SERVICE}
    >{(doUpdate, { loading: doLoading }) => (
      <Modal
        title="อัพเดทงานซ่อม"
        visible={editModal}
        okButtonProps={{
          loading: doLoading,
          disabled: _.includes([servicesStatus.STARTED], service.status) ? _.size(_.filter(partList, o => o.id === '' || o.sku === '' || _.isUndefined(o.amount) || o.amount < 1)) > 0 : false,
        }}
        cancelButtonProps={{ disabled: doLoading }}
        okText='อัพเดทงานซ่อม'
        destroyOnClose={true}
        onCancel={() => {
          setEditModal(false)
          setUpdatedService()
          setSearchMechanic()
        }}
        onOk={() => {
          setUpdatedService({})
          doUpdate({
            variables: {
              ...updatedService,
              id: service.id,
              skillId,
              items: partList.map(v => ({
                id: v.id, amount: v.amount,
              })),
            },
          }).then((resp) => {
            const response = resp.data.UpdateRepairService
            if (response.success) {
              message.success(response.message)
              refetch()
            } else message.error(response.message)
            setEditModal(false)
          })
          setEditModal(false)
          setUpdatedService()
          setSearchMechanic()
        }}
      >
        <Div display='flex' flexDirection='column'>
          {
            _.includes([servicesStatus.ASSIGNED, servicesStatus.STARTED], service.status)
            && <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center' margin='0 0 8px 0'>
              <P bold>ช่าง</P>
              <Query
                query={GET_MECHANICS}
                variables={{ fullname: searchMechanic, limit: 10 }}
              >{({ data, loading, error }) => {
                if (loading && _.isUndefined(data.MechanicList)) return <Loading size='small' />
                if (error) return <P>Error</P>
                return (
                  <Select
                    showSearch
                    defaultValue={service.Mechanic.fullname}
                    style={{ width: '40%' }}
                    loading={loading}
                    onSelect={e => setUpdatedService({ ...updatedService, mechanicId: e })}
                    onSearch={e => setSearchMechanic(e)}
                    placeholder='พิมพ์เพื่อค้นหา'
                    notFoundContent={loading ? <Spin size="small" /> : null}
                    optionFilterProp="children"
                  // disabled={disabled}
                  >
                    {
                      data.MechanicList.lists.map(v => <Select.Option key={v.id} value={v.id}>{v.fullname}</Select.Option>)
                    }
                  </Select>
                )
              }}
              </Query>
            </Div>
          }
          { (!skillLoading || !_.isEmpty(skillData)) && service.serviceType === 'NORMAL'
            && <Div display='flex' flexDirection='column' margin='0'>
            <P margin='8px 0 16px'>ประเภทของงาน *</P>
            <Checkbox.Group
              style={{ width: '100%' }}
              onChange={e => setSkillId(e)}
              defaultValue={_.map(service.RepairSkill, w => w.id)}
            >
            <Row>
            {_.map(skillData.RepairSkillList.lists, (v) => {
              if (v.name === 'ยาง') return ''
              return (
                <Col span={12} style={{ margin: '8px 0' }}>
                  <Checkbox value={v.id}>
                    <P>{v.name}</P>
                  </Checkbox>
                </Col>
              )
            })}
            </Row>
            </Checkbox.Group>
          </Div>
          }
          <P bold margin='0 0 8px 0'>รายละเอียด</P>
          <AntInput.TextArea defaultValue={service.remark} onChange={e => setUpdatedService({ ...updatedService, remark: e.target.value })} />
          <P bold margin='16px 0'>รูปก่อนซ่อม</P>
          <UploadWithModal
            defaultFileList={_.size(service.BeforeRepairFiles) > 0 && service.BeforeRepairFiles.map(v => ({
              name: v.filename,
              url: v.url,
              uid: v.url,
            }))}
            onChange={e => setUpdatedService({ ...updatedService, beforeRepairImages: e.fileList.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)) })}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            listType='picture'
          />
        </Div>
      </Modal>
    )}
    </Mutation>
  )
}

const AssignMechanic = ({
  assignMechanicModal, setAssignMechanicModal, refetch, service,
}) => {
  const [updatedService, setUpdatedService] = useState({})
  const [searchMechanic, setSearchMechanic] = useState()

  return (
    <Mutation
      mutation={ASSIGN_MECHANIC}
    >{(doAssignMechanic, { loading: doLoading }) => (
      <Modal
        title="จ่ายงาน"
        visible={assignMechanicModal}
        okButtonProps={{
          loading: doLoading,
          disabled: _.isUndefined(updatedService.mechanicId),
        }}
        cancelButtonProps={{ disabled: doLoading }}
        okText='จ่ายงาน'
        destroyOnClose={true}
        onCancel={() => {
          setAssignMechanicModal(false)
          setUpdatedService({})
          setSearchMechanic()
        }}
        onOk={() => {
          setUpdatedService({})
          doAssignMechanic({
            variables: { ...updatedService, id: service.id },
          }).then((resp) => {
            const response = resp.data.AssignMechanicToRepairService
            if (response.success) {
              message.success(response.message)
              refetch()
            } else message.error(response.message)
          })
          setAssignMechanicModal(false)
          setUpdatedService({})
          setSearchMechanic()
        }}
      >
        <Div display='flex' flexDirection='column'>
          <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center' margin='0 0 8px 0'>
            <P bold>ช่าง</P>
            <Query
              query={GET_MECHANICS}
              variables={{ fullname: searchMechanic, limit: 10 }}
            >{({ data, loading, error }) => {
              if (loading && _.isUndefined(data.MechanicList)) return <Loading size='small' />
              if (error) return <P>Error</P>
              return (
                <Select
                  showSearch
                  defaultValue={service.Mechanic.fullname}
                  style={{ width: '40%' }}
                  loading={loading}
                  onSelect={e => setUpdatedService({ ...updatedService, mechanicId: e })}
                  onSearch={e => setSearchMechanic(e)}
                  placeholder='พิมพ์เพื่อค้นหา'
                  notFoundContent={loading ? <Spin size="small" /> : null}
                  optionFilterProp="children"
                // disabled={disabled}
                >
                  {
                    data.MechanicList.lists.map(v => <Select.Option key={v.id} value={v.id}>{v.fullname}</Select.Option>)
                  }
                </Select>
              )
            }}
            </Query>
          </Div>
        </Div>
      </Modal>
    )}
    </Mutation>
  )
}

const StartService = ({
  startServiceModal, setStartServiceModal, refetch, service, info, inventoryData, inventoryRefetch, inventoryLoading,
}) => {
  const [updatedService, setUpdatedService] = useState()
  const [partList, setPartList] = useState([])

  return (
    <Mutation
      mutation={START_SERVICE}
    >{(doStart, { loading: doLoading }) => (
      <Modal
        title="เริ่มงาน"
        visible={startServiceModal}
        okButtonProps={{
          loading: doLoading,
          disabled: _.size(_.filter(partList, o => o.id === '' || _.isUndefined(o.amount) || _.isNull(o.amount) || o.amount < 1 || _.isUndefined(o.pricePerItem) || _.isNull(o.pricePerItem) || o.pricePerItem <= 0)) > 0,
        }}
        cancelButtonProps={{ disabled: doLoading }}
        okText='เริ่มงาน'
        destroyOnClose={true}
        width='1280px'
        onCancel={() => {
          setUpdatedService()
          setPartList([])
          setStartServiceModal(false)
        }}
        onOk={() => {
          setUpdatedService({})
          doStart({
            variables: {
              ...updatedService,
              id: service.id,
              items: partList.map(v => ({
                id: v.id, amount: v.amount, pricePerItem: v.pricePerItem,
              })),
            },
          }).then((resp) => {
            const response = resp.data.AssignMechanicStartRepair
            if (response.success) {
              message.success(response.message)
              refetch()
            } else message.error(response.message)
          })
          setStartServiceModal(false)
          setUpdatedService()
          setPartList([])
        }}
      >
        <Div display='flex' flexDirection='column' justifyContent='center'>
          <Row gutter={8} style={{ marginBottom: 8 }} align='middle' type='flex'>
            <Col span={3}>
              <P>รหัสสินค้า</P>
            </Col>
            <Col span={7}>
              <P>ชื่อสินค้า</P>
            </Col>
            <Col span={5}>
              <P>คลังสินค้า</P>
            </Col>
            <Col span={3}>
              <P>จำนวนในคลัง</P>
            </Col>
            <Col span={3}>
              <P>จำนวนที่เบิก</P>
            </Col>
            <Col span={2}>
              <P>ราคา *</P>
            </Col>
          </Row>
          {(!inventoryLoading || !_.isEmpty(inventoryData))
            && partList.map((v, index) => (
              <Row key={v.id} gutter={8} style={{ marginBottom: 8 }} align='middle' type='flex'>
                <Col span={3}>
                  <P>{partList[index].sku}</P>
                </Col>
                <Col span={7}>
                  <Select
                    showSearch
                    style={{ width: '100%' }}
                    loading={inventoryLoading}
                    value={partList[index].productName}
                    onSelect={(e) => {
                      if (!_.some(partList, { productName: e })) {
                        const selected = _.find(inventoryData.inventoryList.data.list, o => o.productName === e)
                        const newPartList = _.cloneDeep(partList)
                        newPartList.splice(index, 1, {
                          id: selected.inventoryOptions[0].id,
                          sku: selected.sku,
                          productName: e,
                          pricePerItem: selected.inventoryOptions[0].buyPrice,
                          preorderItemQuantity: _.find(selected.inventoryOptions[0].stockLocation, o => o.warehouse.warehouseName === info.Warehouse.warehouseName).preorderItemQuantity,
                          totalAmount: _.find(selected.inventoryOptions[0].stockLocation, o => o.warehouse.warehouseName === info.Warehouse.warehouseName).quantity,
                        })
                        setPartList([...newPartList])
                      }
                    }}
                    onSearch={e => inventoryRefetch({ productName: e })}
                    placeholder='พิมพ์เพื่อค้นหา'
                  >
                    {
                      inventoryData.inventoryList.data.list.map(u => <Select.Option key={u.id} value={u.productName}>{u.productName}</Select.Option>)
                    }
                  </Select>
                </Col>
                <Col span={5}>
                  <P>{info.Warehouse.warehouseName}</P>
                </Col>
                <Col span={3}>
                  <P>{partList[index].totalAmount}</P>{partList[index].preorderItemQuantity > 0 && <P margin='0 0 0 8px'>(+{partList[index].preorderItemQuantity})</P>}
                </Col>
                <Col span={3}><Input width='100%' placeholder='จำนวน' onChange={(e) => {
                  const newPartList = _.cloneDeep(partList)
                  newPartList[index].amount = parseInt(e.target.value, 10)
                  setPartList([...newPartList])
                }}
                  onKeyDown={(e) => {
                    if (!checkInt(e)) {
                      e.preventDefault()
                    }
                  }}
                /></Col>
                <Col span={2}><Input width='100%' placeholder='ราคา' onChange={(e) => {
                  const newPartList = _.cloneDeep(partList)
                  newPartList[index].pricePerItem = parseFloat(e.target.value, 10)
                  setPartList([...newPartList])
                }}
                  defaultValue = {v.pricePerItem}
                  onKeyDown={(e) => {
                    if (!checkFloat(e)) {
                      e.preventDefault()
                    }
                  }}
                /></Col>
                <Col span={1}><Icon
                  className="dynamic-delete-button"
                  type="minus-circle-o"
                  onClick={() => {
                    const oldPartList = _.cloneDeep(partList)
                    _.remove(oldPartList, n => n.id === v.id)
                    setPartList(oldPartList)
                  }}
                /></Col>
              </Row>
            ))
          }
          <Button type="dashed" onClick={() => {
            setPartList([...partList, {
              id: partList.length, sku: '',
            }])
          }}>
            <Icon type="plus" /> เบิกอะไหล่
          </Button>
          {/* <P bold margin='0 0 8px 0'>รายละเอียด</P>
          <AntInput.TextArea onChange={e => setNewService({ ...newService, remark: e.target.value })}/> */}
          <P bold margin='16px 0'>รูปก่อนซ่อม</P>
          <UploadWithModal
            defaultFileList={_.size(service.BeforeRepairFiles) > 0 && service.BeforeRepairFiles.map(v => ({
              name: v.filename,
              url: v.url,
              uid: v.url,
            }))}
            onChange={e => setUpdatedService({ ...updatedService, beforeRepairImages: e.fileList.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)) })}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            listType='picture'
          />
        </Div>
      </Modal>
    )}
    </Mutation>
  )
}

const StartServiceTire = ({
  startServiceTireModal, setStartServiceTireModal, refetch, service, info, tireSerialNumberData, tireSerialNumberRefetch, tireSerialNumberLoading,
}) => {
  const [updatedService, setUpdatedService] = useState()
  const [partList, setPartList] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const {
    loading: oldTireSerialNumberLoading, data: oldTireSerialNumberData, error: oldTtireSerialNumberError, refetch: oldTireSerialNumberRefetch,
  } = useQuery(TIRE_SERIAL_NUMBER_LIST, {
    variables: !service.isRepairTrailer ? { plateNumber: info.Truck.plateNumber } : { trailerPlate: info.Trailer.trailerPlate },
  })

  return (
    <Mutation
      mutation={START_SERVICE_TIRE}
    >{(doStart, { loading: doLoading }) => (
      <Modal
        title="เริ่มงาน"
        visible={startServiceTireModal}
        okButtonProps={{
          loading: doLoading,
          disabled: _.size(_.filter(partList, o => (_.isUndefined(o.serialId) && _.isUndefined(o.oldSerialId)) || _.isUndefined(o.wheelNo))) > 0,
        }}
        cancelButtonProps={{ disabled: doLoading }}
        width='1280px'
        okText='เริ่มงาน'
        destroyOnClose={true}
        onCancel={() => {
          setUpdatedService()
          setPartList([])
          setStartServiceTireModal(false)
        }}
        onOk={() => {
          setUpdatedService({})
          doStart({
            variables: {
              ...updatedService,
              id: service.id,
              items: partList.map(v => ({
                serialId: v.serialId, oldSerialId: v.oldSerialId, wheelNo: v.wheelNo,
              })),
            },
          }).then((resp) => {
            const response = resp.data.AssignMechanicStartRepairTire
            if (response.success) {
              message.success(response.message)
              refetch()
            } else message.error(response.message)
          })
          setStartServiceTireModal(false)
          setUpdatedService()
          setPartList([])
        }}
        footer={[
          <Div key='key' display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
          <Div>
            <Button
              key="pdf"
              style={{ background: '#a9c268', color: '#FFFFFF' }}
              margin='0 16px 0 0'
              disabled={isLoading}
              onClick={() => {
                setIsLoading(true)
                window.open(
                  `${getURL().FILE_SERVER}/render/pdf/tireUsedLogsBySerial?serialId=${_.compact(partList.map(v => v.oldSerialId)).join(',')}&repairjobId=${info.id}&truckId=${!service.isRepairTrailer ? info.Truck.id : undefined}&trailerId=${!service.isRepairTrailer ? undefined : info.Trailer.id}&t=${getAccessToken()}`,
                  '_blank',
                  'toolbar=false,scrollbars=yes,resizable=false',
                )
                setIsLoading(false)
              }}
              >
              พิมพ์ประวัติยางเก่า
            </Button>
            <Button disabled={!_.includes(window.perms, PERMISSION.VIEW_TRUCK)} style={{ background: '#a9c268', color: '#FFFFFF' }}>
              <Link target="_blank" to={!service.isRepairTrailer ? `/truck/tire-list/${info.Truck.id}` : `/trailer/tire-list/${info.Trailer.id}`}>
              ดูข้อมูลล้อ
              </Link>
            </Button>
          </Div>
          <Div>
          <Button
            key="cancel"
            disabled={doLoading}
            onClick={() => {
              setUpdatedService()
              setPartList([])
              setStartServiceTireModal(false)
            }}
          >
            ยกเลิก
          </Button>
          <Button
            key="submit"
            type="primary"
            loading={doLoading}
            disabled={_.size(_.filter(partList, o => (_.isUndefined(o.serialId) && _.isUndefined(o.oldSerialId)) || _.isUndefined(o.wheelNo))) > 0}
            onClick={() => {
              setUpdatedService({})
              doStart({
                variables: {
                  ...updatedService,
                  id: service.id,
                  items: partList.map(v => ({
                    serialId: v.serialId, oldSerialId: v.oldSerialId, wheelNo: v.wheelNo,
                  })),
                },
              }).then((resp) => {
                const response = resp.data.AssignMechanicStartRepairTire
                if (response.success) {
                  message.success(response.message)
                  refetch()
                } else message.error(response.message)
              })
              setStartServiceTireModal(false)
              setUpdatedService()
              setPartList([])
            }}
            >
            เริ่มงาน
          </Button>
          </Div>
          </Div>,
        ]}
      >
        <Div display='flex' flexDirection='column' justifyContent='center'>
          <Row gutter={8} style={{ marginBottom: 8 }} align='middle' type='flex'>
            <Col span={5}>
              <P>เบอร์ยางที่ถอด</P>
            </Col>
            <Col span={2}>
              <P>ล้อที่ *</P>
            </Col>
            <Col span={5}>
              <P>เบอร์ยางที่จะเบิก</P>
            </Col>
            <Col span={7}>
              <P>ชื่อยางที่จะเบิก</P>
            </Col>
            <Col span={4}>
              <P>สถานะยางที่เบิก</P>
            </Col>
          </Row>
          {(!oldTireSerialNumberLoading || !_.isEmpty(oldTireSerialNumberData) || tireSerialNumberLoading || !_.isEmpty(tireSerialNumberData))
            && partList.map((v, index) => (
              <Row key={v.id} gutter={8} style={{ marginBottom: 8 }} align='middle' type='flex'>
                <Col span={5}>
                  <Select
                    showSearch
                    style={{ width: '100%' }}
                    loading={oldTireSerialNumberLoading}
                    value={partList[index].oldSerialNumber}
                    onSelect={(e) => {
                      if (!_.some(partList, { oldSerialNumber: e })) {
                        const selected = _.find(oldTireSerialNumberData.TireSerialNumberList.lists, o => o.serialNumber === e)
                        const newPartList = _.cloneDeep(partList)
                        newPartList[index].oldSerialId = selected.id
                        newPartList[index].oldSerialNumber = e
                        if (service.isRepairTruck) newPartList[index].wheelNo = selected.TruckTires.wheelNo
                        else newPartList[index].wheelNo = selected.TrailerTires.wheelNo
                        setPartList([...newPartList])
                      }
                    }}
                    onSearch={e => oldTireSerialNumberRefetch({ serialNumber: e })}
                    placeholder='พิมพ์เพื่อค้นหา'
                  >
                    {
                      oldTireSerialNumberData?.TireSerialNumberList?.lists.map(u => <Select.Option key={u.id} value={u.serialNumber}>{u.serialNumber}</Select.Option>)
                    }
                  </Select>
                </Col>
                <Col span={2}>
                  {/* <P>{partList[index].wheelNo}</P> */}
                  <Input
                    width='100%'
                    value={v.wheelNo}
                    onChange={(e) => {
                      const newPartList = _.cloneDeep(partList)
                      newPartList[index].wheelNo = e.target.value
                      setPartList([...newPartList])
                    }}
                  />
                </Col>
                <Col span={5}>
                  <Select
                    showSearch
                    style={{ width: '100%' }}
                    loading={tireSerialNumberLoading}
                    value={partList[index].serialNumber}
                    onSelect={(e) => {
                      if (!_.some(partList, { serialNumber: e })) {
                        const selected = _.find(tireSerialNumberData.TireSerialNumberList.lists, o => o.serialNumber === e)
                        const newPartList = _.cloneDeep(partList)
                        newPartList[index].serialId = selected.id
                        newPartList[index].serialNumber = e
                        newPartList[index].status = selected.status
                        newPartList[index].variantName = selected.inventoryOption?.variantName
                        setPartList([...newPartList])
                      }
                    }}
                    onSearch={e => tireSerialNumberRefetch({ serialNumber: e })}
                    placeholder='พิมพ์เพื่อค้นหา'
                  >
                    {
                      tireSerialNumberData?.TireSerialNumberList?.lists.map(u => <Select.Option key={u.id} value={u.serialNumber}>{u.serialNumber}</Select.Option>)
                    }
                  </Select>
                </Col>
                <Col span={7}>
                  <P>{partList[index]?.variantName}</P>
                </Col>
                <Col span={4}>
                  <P>{STATUSTEXTSELECTOR(partList[index].status)}</P>
                </Col>
                <Col span={1}><Icon
                  className="dynamic-delete-button"
                  type="minus-circle-o"
                  onClick={() => {
                    const oldPartList = _.cloneDeep(partList)
                    _.remove(oldPartList, n => n.id === v.id)
                    setPartList(oldPartList)
                  }}
                /></Col>
              </Row>
            ))
          }
          <Button type="dashed" onClick={() => {
            setPartList([...partList, {
              id: partList.length,
            }])
          }}>
            <Icon type="plus" /> เบิกอะไหล่
          </Button>
          {/* <P bold margin='0 0 8px 0'>รายละเอียด</P>
          <AntInput.TextArea onChange={e => setNewService({ ...newService, remark: e.target.value })}/> */}
          <P bold margin='16px 0'>รูปก่อนซ่อม</P>
          <UploadWithModal
            defaultFileList={_.size(service.BeforeRepairFiles) > 0 && service.BeforeRepairFiles.map(v => ({
              name: v.filename,
              url: v.url,
              uid: v.url,
            }))}
            onChange={e => setUpdatedService({ ...updatedService, beforeRepairImages: e.fileList.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)) })}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            listType='picture'
          />
        </Div>
      </Modal>
    )}
    </Mutation>
  )
}

const CloseService = ({
  closeServiceModal, setCloseServiceModal, refetch, service, setCloseJobModal, info, inventoryData, inventoryRefetch, inventoryLoading,
}) => {
  const [updatedService, setUpdatedService] = useState()
  const [partList, setPartList] = useState(service.ItemReturns)

  useEffect(() => { setPartList(!_.isUndefined(service.ItemReturns) ? service.ItemReturns : null) }, [service.ItemReturns])

  return (
    <Mutation
      mutation={CLOSE_SERVICE}
    >{(doClose, { loading: doLoading }) => (
      <Modal
        title="ปิดงาน"
        visible={closeServiceModal}
        width='1280px'
        okButtonProps={{
          loading: doLoading,
          disabled: _.size(_.filter(partList, o => o.id === '' || o.sku === '' || _.isUndefined(o.amount) || o.amount < 1)) > 0,
        }}
        cancelButtonProps={{ disabled: doLoading }}
        okText='ปิดงาน'
        destroyOnClose={true}
        onCancel={() => {
          setCloseServiceModal(false)
          setUpdatedService()
        }}
        onOk={() => {
          setUpdatedService()
          doClose({
            variables: {
              ...updatedService,
              id: service.id,
              items: partList.map(v => ({
                id: v.id, amount: v.amount,
              })),
            },
          }).then((resp) => {
            const response = resp.data.AssignFinishRepairService
            if (response.success) {
              message.success(response.message)
              refetch()
            } else message.error(response.message)
            setCloseServiceModal(false)
            if (response.canCloseJob) {
              Modal.confirm({
                title: `ต้องการปิดงานใบแจ้งซ่อมของ ทะเบียน ${response.UpdatedRepairJob.Truck.plateNumber} เลยหรือไม่?`,
                content: `งานซ่อมของใบนี้เสร็จเรียบร้อยทั้งหมดแล้ว ${(!_.isNull(response.UpdatedRepairJob.remark) && `รายละเอียด: ${response.UpdatedRepairJob.remark}`) || ''}`,
                onOk() {
                  setCloseJobModal(true)
                },
                onCancel() {
                },
                cancelText: 'ภายหลัง',
              })
            }
          })
        }}
      >
        <Div display='flex' flexDirection='column' justifyContent='center' width='100%'>
          <Row gutter={8} style={{ marginBottom: 8 }} align='middle' type='flex'>
            <Col span={4}>
              <P>รหัสสินค้า</P>
            </Col>
            <Col span={7}>
              <P>ชื่อสินค้า</P>
            </Col>
            <Col span={5}>
              <P>คลังสินค้า</P>
            </Col>
            <Col span={3}>
              <P>จำนวนในคลัง</P>
            </Col>
            <Col span={4}>
              <P>จำนวนที่คืน</P>
            </Col>
          </Row>
          {(!inventoryLoading || !_.isEmpty(inventoryData))
            && partList.map((v, index) => (
              <Row key={v.id} gutter={8} style={{ marginBottom: 8 }} align='middle' type='flex'>
                <Col span={4}>
                  {/* <Select
                    showSearch
                    style={{ width: '100%' }}
                    loading={inventoryLoading}
                    value={partList[index].sku}
                    onSelect={(e) => {
                      const selected = _.find(inventoryData.inventoryList.data.list, o => o.sku === e)
                      // const oldPartList = _.cloneDeep(partList)
                      // const newPartList = _.remove(oldPartList, n => n.id === v.id)
                      const newPartList = _.cloneDeep(partList)
                      newPartList.splice(index, 1, {
                        id: selected.inventoryOptions[0].id,
                        sku: e,
                        name: selected.productName,
                        totalAmount: _.find(selected.inventoryOptions[0].stockLocation, o => o.warehouse.warehouseName === info.Warehouse.warehouseName).quantity,
                      })
                      setPartList([...newPartList])
                    }}
                    onSearch={e => inventoryRefetch({ sku: e })}
                    placeholder='พิมพ์เพื่อค้นหา'
                  >
                    {
                      inventoryData.inventoryList.data.list.map(u => <Select.Option key={u.id} value={u.sku}>{u.sku}</Select.Option>)
                    }
                  </Select> */}
                  <P>{partList[index].sku}</P>
                </Col>
                <Col span={7}>
                  {/* <P>{partList[index].name}</P> */}
                  <Select
                    showSearch
                    style={{ width: '100%' }}
                    loading={inventoryLoading}
                    value={partList[index].productName}
                    onSelect={(e) => {
                      if (!_.some(partList, { productName: e })) {
                        const selected = _.find(inventoryData.inventoryList.data.list, o => o.productName === e)
                        // const oldPartList = _.cloneDeep(partList)
                        // const newPartList = _.remove(oldPartList, n => n.id === v.id)
                        const newPartList = _.cloneDeep(partList)
                        newPartList.splice(index, 1, {
                          id: selected.inventoryOptions[0].id,
                          sku: selected.sku,
                          productName: e,
                          totalAmount: _.find(selected.inventoryOptions[0].stockLocation, o => o.warehouse.warehouseName === info.Warehouse.warehouseName).quantity,
                        })
                        setPartList([...newPartList])
                      }
                    }}
                    onSearch={e => inventoryRefetch({ productName: e })}
                    placeholder='พิมพ์เพื่อค้นหา'
                  >
                    {
                      inventoryData.inventoryList.data.list.map(u => <Select.Option key={u.id} value={u.productName}>{u.productName}</Select.Option>)
                    }
                  </Select>
                </Col>
                <Col span={5}>
                  <P>{info.Warehouse.warehouseName}</P>
                </Col>
                <Col span={3}>
                  <P>{partList[index].totalAmount}</P>
                </Col>
                <Col span={4}><Input width='100%' placeholder='จำนวน' onChange={(e) => {
                  const newPartList = _.cloneDeep(partList)
                  newPartList[index].amount = parseInt(e.target.value, 10)
                  setPartList([...newPartList])
                }}
                  onKeyDown={(e) => {
                    if (!checkInt(e)) {
                      e.preventDefault()
                    }
                  }}
                /></Col>
                <Col span={1}><Icon
                  className="dynamic-delete-button"
                  type="minus-circle-o"
                  onClick={() => {
                    const oldPartList = _.cloneDeep(partList)
                    _.remove(oldPartList, n => n.id === v.id)
                    setPartList(oldPartList)
                  }}
                /></Col>
              </Row>
            ))
          }
          <Button type="dashed" onClick={() => {
            setPartList([...partList, {
              id: partList.length, sku: '',
            }])
          }}>
            <Icon type="plus" /> คืนอะไหล่
          </Button>
          {/* <P bold margin='0 0 8px 0'>รายละเอียด</P>
          <AntInput.TextArea onChange={e => setNewService({ ...newService, remark: e.target.value })}/> */}
          <P bold margin='16px 0'>รูปหลังซ่อม</P>
          <UploadWithModal
            defaultFileList={_.size(service.AfterRepairFiles) > 0 && service.AfterRepairFiles.map(v => ({
              name: v.filename,
              url: v.url,
              uid: v.url,
            }))}
            onChange={e => setUpdatedService({ ...updatedService, afterRepairImages: e.fileList.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)) })}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            listType='picture'
          />
        </Div>
      </Modal>
    )}
    </Mutation>
  )
}

const CloseServiceTire = ({
  closeServiceTireModal, setCloseServiceTireModal, refetch, service, setCloseJobModal, info, tireSerialNumberData, tireSerialNumberRefetch, tireSerialNumberLoading,
}) => {
  const [updatedService, setUpdatedService] = useState()
  const [partList, setPartList] = useState(service.ItemReturns)

  useEffect(() => { setPartList(!_.isUndefined(service.ItemReturns) ? service.ItemReturns : null) }, [service.ItemReturns])

  return (
    <Mutation
      mutation={CLOSE_SERVICE_TIRE}
    >{(doClose, { loading: doLoading }) => (
      <Modal
        title="ปิดงาน"
        visible={closeServiceTireModal}
        width='800px'
        okButtonProps={{
          loading: doLoading,
          disabled: _.size(_.filter(partList, o => o.serialId === '' || _.isUndefined(o.status) || (o.status === 'LOST' && _.isUndefined(o.lostReason)))) > 0,
        }}
        cancelButtonProps={{ disabled: doLoading }}
        okText='ปิดงาน'
        destroyOnClose={true}
        onCancel={() => {
          setCloseServiceTireModal(false)
          setUpdatedService()
        }}
        onOk={() => {
          setUpdatedService()
          doClose({
            variables: {
              ...updatedService,
              id: service.id,
              items: partList.map(v => ({
                serialId: v.serialId, status: v.status, lostReason: v.lostReason,
              })),
            },
          }).then((resp) => {
            const response = resp.data.AssignFinishRepairServiceTire
            if (response.success) {
              message.success(response.message)
              refetch()
            } else message.error(response.message)
            setCloseServiceTireModal(false)
            if (response.canCloseJob) {
              Modal.confirm({
                title: `ต้องการปิดงานใบแจ้งซ่อมของ ทะเบียน ${response.UpdatedRepairJob.Truck.plateNumber} เลยหรือไม่?`,
                content: `งานซ่อมของใบนี้เสร็จเรียบร้อยทั้งหมดแล้ว ${(!_.isNull(response.UpdatedRepairJob.remark) && `รายละเอียด: ${response.UpdatedRepairJob.remark}`) || ''}`,
                onOk() {
                  setCloseJobModal(true)
                },
                onCancel() {
                },
                cancelText: 'ภายหลัง',
              })
            }
          })
        }}
      >
        <Div display='flex' flexDirection='column' justifyContent='center' width='100%'>
          { service.ItemReturns.length > 0
            && <Row gutter={8} style={{ marginBottom: 8 }} align='middle' type='flex'>
              <Col span={8}>
                <P>เบอร์ยางที่ถอด</P>
              </Col>
              <Col span={8}>
                <P>เลือกสถานะยางที่ถอด</P>
              </Col>
            </Row>
          }
          {(!tireSerialNumberLoading || !_.isEmpty(tireSerialNumberData))
            && partList.map((v, index) => (
              <Row key={v.id} gutter={8} style={{ marginBottom: 8 }} align='middle' type='flex'>
                <Col span={8}>
                  <P>{partList[index].serialNo}</P>
                </Col>
                <Col span={8}>
                  <DropdownSelector
                    width={250}
                    key='filter'
                    data={STATUSRETURN}
                    handleChange={(e) => {
                      const newPartList = _.cloneDeep(partList)
                      newPartList[index].status = e
                      setPartList([...newPartList])
                    }}
                    filter={false}
                    statusAttr='ทั้งหมด'
                  />
                </Col>
                <Col span={8}>
                  {partList[index].status === 'LOST'
                    && <AutoComplete
                      dataSource={LOSTREASON}
                      value={partList[index].lostReason}
                      style={{ width: '100%' }}
                      onSelect={(e) => {
                        const newPartList = _.cloneDeep(partList)
                        newPartList[index].lostReason = e
                        setPartList([...newPartList])
                      }}
                      onSearch={(e) => {
                        const newPartList = _.cloneDeep(partList)
                        newPartList[index].lostReason = e
                        setPartList([...newPartList])
                      }}
                      placeholder="กรุณาระบุสาเหตุ"
                    />
                  }
                </Col>
              </Row>
            ))
          }
          {/* <P bold margin='0 0 8px 0'>รายละเอียด</P>
          <AntInput.TextArea onChange={e => setNewService({ ...newService, remark: e.target.value })}/> */}
          <P bold margin='16px 0'>รูปหลังซ่อม</P>
          <UploadWithModal
            defaultFileList={_.size(service.AfterRepairFiles) > 0 && service.AfterRepairFiles.map(v => ({
              name: v.filename,
              url: v.url,
              uid: v.url,
            }))}
            onChange={e => setUpdatedService({ ...updatedService, afterRepairImages: e.fileList.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)) })}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            listType='picture'
          />
        </Div>
      </Modal>
    )}
    </Mutation>
  )
}

const CancelService = ({
  cancelServiceModal, setCancelServiceModal, refetch, service, setCloseJobModal,
}) => {
  const [reason, setReason] = useState('')

  return (
    <Mutation
      mutation={CANCEL_SERVICE}
    >{(doClose, { loading: doLoading }) => (
      <Modal
        title="ยกเลิกงาน"
        visible={cancelServiceModal}
        okButtonProps={{
          loading: doLoading,
          disabled: reason === '',
        }}
        cancelButtonProps={{ disabled: doLoading }}
        okText='ยกเลิกงาน'
        destroyOnClose={true}
        onCancel={() => {
          setCancelServiceModal(false)
          setReason('')
        }}
        onOk={() => {
          setReason('')
          doClose({
            variables: {
              cancelReason: reason,
              id: service.id,
            },
          }).then((resp) => {
            const response = resp.data.CancelRepairService
            if (response.success) {
              message.success(response.message)
              refetch()
            } else message.error(response.message)
            setCancelServiceModal(false)
            if (response.canCloseJob) {
              message.confirm({
                title: `ต้องการปิดงานใบแจ้งซ่อมของ ทะเบียน ${response.UpdatedRepairJob.Truck.plateNumber} เลยหรือไม่?`,
                content: `งานซ่อมของใบนี้เสร็จเรียบร้อยทั้งหมดแล้ว รายละเอียด: ${response.UpdatedRepairJob.remark}`,
                onOk() {
                  setCloseJobModal(true)
                },
                onCancel() {
                },
              })
            }
          })
        }}
      >
        <Div display='flex' flexDirection='column' justifyContent='center' width='100%'>
          <P bold margin='0 0 8px 0'>เหตุผลการยกเลิก</P>
          <AntInput.TextArea onChange={e => setReason(e.target.value)} />
        </Div>
      </Modal>
    )}
    </Mutation>
  )
}
